module.exports = new __parcel__URL__("hiphop.8a6f091c.mp4").toString();